import { render, staticRenderFns } from "./IconControls.vue?vue&type=template&id=217377ca&"
import script from "./IconControls.vue?vue&type=script&lang=js&"
export * from "./IconControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports